import { HometrackUpgradeButton } from "react-migration/layouts/map/Multilayer/layer_types/ComparablesLayerType/HometrackUpgradeButton";
import { UpgradeEventLocation } from "react-migration/lib/util/logEventV2";
import { HomeTrackLogoLarge } from "react-migration/domains/comparables/img/HomeTrackLogoLarge";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import hasFeature from "src/js/stores/user/actions/hasFeature";
import Feature from "src/js/stores/user/Feature";

export const HTUpgradeDataCard = ({ source }: { source: UpgradeEventLocation }) => {
  const { t } = useTranslation();

  if (hasFeature(Feature.zooplaFullAccess)) {
    return null;
  }

  return (
    <div className="w-full px-3 py-4 bg-white border rounded-lg shadow-xs border-blue-grey-300">
      <div className="flex flex-col items-start justify-center gap-2">
        <div className="flex flex-col items-start justify-center">
          <div className="w-full flex items-center justify-start text-xs md:text-sm font-bold gap-[6px]">
            {t("workbench.upgrade_to_access.unlock_local_market_insights")}
            <HomeTrackLogoLarge width={94} height={11} />
          </div>
          <div className="font-medium text-3xs text-blue-grey-600a">
            {t("workbench.upgrade_to_access.understand_the_market_a_year_ahead_of_the_competition")}
          </div>
        </div>
        <div className="flex items-stretch justify-start w-full">
          <HometrackUpgradeButton logClickSource={source} className="grow" />
        </div>
      </div>
    </div>
  );
};
